import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ListarCapController } from "../../../../Controllers/Geral/LancamentoCustas/LancamentoCustasController";
import SpinnerUAU from "../../../Loding/SpinnerUAU";
import { Select } from "antd";
import type { OptionCoreData } from "rc-select/lib/interface/index";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";

import "./styles.css";

interface IPropsModal {
    active: boolean;
}

const CapsObject: Array<{
    name:
        | "CapPrincipal"
        | "CapAcrescimo"
        | "CapCorrecao"
        | "CapCorrecaoAtraso"
        | "CapDesconto"
        | "CapDescontoAntecipacao"
        | "CapDescontoCusta"
        | "CapJuros"
        | "CapJurosAtraso"
        | "CapMulta"
        | "CapRepasse"
        | "CapTaxaBoleto";
    label: string;
}> = [
    { name: "CapPrincipal", label: "Cap Principal" },
    { name: "CapAcrescimo", label: "Acréscimo" },
    { name: "CapCorrecao", label: "Correção" },
    { name: "CapCorrecaoAtraso", label: "Correção Atraso" },
    { name: "CapDesconto", label: "Desconto" },
    { name: "CapDescontoAntecipacao", label: "Descontp Antecipação" },
    { name: "CapDescontoCusta", label: "Desconto Custa" },
    { name: "CapJuros", label: "Juros" },
    { name: "CapJurosAtraso", label: "Juros Atraso" },
    { name: "CapMulta", label: "Multa" },
    { name: "CapRepasse", label: "Repasse" },
    { name: "CapTaxaBoleto", label: "Taxa Boleto" },
];

export function AdionarCap(props: IPropsModal) {
    const { formState, control, getValues, setValue } = useFormContext();
    const [options, setOptions] = useState<Array<OptionCoreData>>();

    useEffect(() => {
        ListarCapController().then((res) => {
            setOptions(
                res?.map((cap) => ({
                    label: `${cap.Codigo_cger} - ${cap.Desc_cger}`,
                    value: cap.Codigo_cger,
                }))
            );
        });
    }, []);

    return (
        <div className="d-flex flex-wrap justify-content-center col-12">
            {options && options.length > 0 ? (
                <div className="row">
                    {CapsObject.map((cap) => (
                        <div
                            className="d-flex flex-wrap justify-content-center col-md-6 my-1"
                            key={cap.name}
                        >
                            <label className="d-flex align-items-center">
                                {cap.label}:
                            </label>
                            <div className="w-100 d-flex align-items-center">
                                <Controller
                                    name={`cap.${cap.name}`}
                                    control={control}
                                    rules={{
                                        validate: (v) => !props.active || !!v,
                                    }}
                                    defaultValue={null}
                                    render={(field) => (
                                        <Select
                                            disabled={!props.active}
                                            className={`ant-select-custom-input flex-grow-1 fix-overflow ${
                                                formState?.errors?.cap?.[
                                                    cap.name
                                                ] && "is-invalid"
                                            }`}
                                            options={options}
                                            {...field}
                                        />
                                    )}
                                />

                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="copy-tooltip">
                                            Replicar valor para todos Caps
                                        </Tooltip>
                                    }
                                >
                                    <div
                                        className="text-primary text-hover-info pl-3"
                                        role="button"
                                        onClick={() => {
                                            const valueCap = getValues(
                                                `cap.${cap.name}`
                                            );
                                            if (valueCap) {
                                                CapsObject.forEach((c) => {
                                                    setValue(
                                                        `cap.${c.name}`,
                                                        valueCap
                                                    );
                                                });
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCopy} />
                                    </div>
                                </OverlayTrigger>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <SpinnerUAU />
            )}
        </div>
    );
}
